import React from "react";
import { DotLabel } from "../Dot";
import AppointmentPhase from "components/Atoms/AppointmentPhase";

interface Props {
  status: server.dto.StatusSmall
  small?: boolean
  linkTo?: string
  displayPhaseIcon?: boolean
}

const Status = (props: Props) => {
  const { status, small, linkTo } = props;

  return <div className="flex gap">
    {props.displayPhaseIcon && <div><AppointmentPhase value={status.appointmentPhase} displayLabel={false} /></div>}

    <DotLabel
      dotColor={status.hexColor}
      small={small}
      linkTo={linkTo}
    >{status.title}</DotLabel>
  </div>
};

export default Status;